export default "__VITE_ASSET__DZaB6HVy__"